/**
 * Display of a relative calendar period used in Briefings
 */

import CalendarPeriodSelector from './calendar-period-selector'

import calendars from 'scoreboard/components/calendars'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import RelativeOptions from 'scoreboard/components/relative-options'
import PeriodDisplay from 'scoreboard/components/period-display'

// this is the calendar period selector for slides with relative periods
var RelativeCalendarPeriodSelector = CalendarPeriodSelector.extend({

	events: _.extend({}, CalendarPeriodSelector.prototype.events, {
		'change select': '_changePeriod'
	}),

	render: function() {
		CalendarPeriodSelector.prototype.render.apply(this, arguments)
		// Add "Actual Period" to the top of the selector
		this.$el.prepend('<div class="actual-period-dropdowns">' + _.escape(i18n.get('common.calendar.period.actual')) + '</div>')
		// If relative period is not current period, display the explaination showing the relationship to the current period.
		if (this.options.periodDelta !== 0) {
			// add "Slide is 2 periods ago: November 2015" above primary
			var relativeText = new RelativeOptions().label(this.options.periodDelta)
			var relativeHtml = ' <span class="relative-text">'
			+ _.escape(relativeText) + '</span>'
			let relativePeriodId = this.$('select.period').val()
			let label = calendars.safeRelativePeriod(relativePeriodId, this.options.periodDelta).label
			var relativeExplanation = '<div class="slide-information">'
				+ i18n.get('briefingBooks.slide.relative', relativeHtml)
				+ '<span class="relative-period">'
				+ _.escape(label)
				+ '</span></div>'
			this.$('.back-to-default-period-container').before(relativeExplanation)
		}
		return this
	},

	_changePeriod: function() {
		var periodId = this.$('select.period').val()
		var relativePeriod = calendars.safeRelativePeriod(periodId, this.options.periodDelta)
		this.$('.relative-period').text(relativePeriod.label)
	}

})

// this is the period display for slides with relative periods
var RelativePeriodDisplay = PeriodDisplay.extend({

	// this.options.periodDelta is the delta of a bb slide

	selectorView: RelativeCalendarPeriodSelector,

	update: function(periodId) {
		PeriodDisplay.prototype.update.apply(this, arguments)
		// If relative period is not current period, display the explaination showing the relationship to the current period.
		if (this.options.periodDelta !== 0) {
			var relativeText = new RelativeOptions().label(this.options.periodDelta)
			var relativeHtml = ' <span class="relative-text">('
			+ _.escape(relativeText) + ')</span>'
			this.$('.text').append(relativeHtml)
		}
	}

})

export default RelativePeriodDisplay

RelativePeriodDisplay.__filename__ = 'components/relative-period-display.js'
